module.exports = __webpack_public_path__ + "static/media/on_the_table.19a250b5.gif";